import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IRating } from "./models/ratings";

@Injectable({
  providedIn: "root",
})
export class RatingsService {
  public list: { id: number; name: string }[] = [];

  public baseUrl: string = "/judgment";

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient.get<IRating[]>(this.baseUrl).toPromise();
  }

  async create(data: IRating) {
    return this._httpClient.post(this.baseUrl, data).toPromise();
  }

  async update(id: number, data: IRating) {
    return this._httpClient.put(this.baseUrl + "/" + id, data).toPromise();
  }

  async delete(id: number) {
    return this._httpClient.delete(this.baseUrl + "/" + id).toPromise();
  }
}
